import axios from '@/util/request'

export function login (data) {
  let url = '/api/v1/login/'
  return axios.post(url, data)
}

export function logout () {
  let url = '/api/v1/logout/'
  return axios.get(url)
}

export function getUserTypes () {
  let url = '/api/v1/user/types'
  return axios.get(url)
}

export function getUsers (param) {
  let url = '/api/v1/user/list?' + (Object.keys(param).map(x => `${x}=${param[x]}`).join('&'))
  return axios.get(url)
}

export function changePwd (param) {
  let url = '/api/v1/user/change_password'
  return axios.post(url, param)
}

export function updateUser (data) {
  let url = '/api/v1/user/update'
  return axios.post(url, data)
}

export function toggleUsers (data) {
  let url = '/api/v1/user/toggle'
  return axios.post(url, data)
}

export function addUser (data) {
  let url = '/api/v1/user/insert'
  return axios.post(url, data)
}
